import { DateTimeField } from '@mews-commander/form';
import { lt } from '@mews/framework';

interface DateTimeIntervalFilterFieldsProps {
    startDateFieldName: string;
    endDateFieldName: string;
}

export const DateTimeIntervalFilterFields = ({
    startDateFieldName,
    endDateFieldName,
}: DateTimeIntervalFilterFieldsProps) => (
    <>
        <DateTimeField label={lt('Start')} required name={startDateFieldName} />
        <DateTimeField label={lt('End')} required name={endDateFieldName} />
    </>
);
